import { render, staticRenderFns } from "./BusinessForms1042S.vue?vue&type=template&id=6b2108b5&"
import script from "./BusinessForms1042S.vue?vue&type=script&lang=ts&"
export * from "./BusinessForms1042S.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessForms1042S.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports